<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>New Daily report</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_date"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Date"
                      v-model="dateFormatted"
                      prepend-icon="event"
                      readonly
                      :rules="itemRules"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.date" no-title scrollable
                  @input="dateFormatted = formatDate($event)"
                  @change="menu_date=false"
                  >
                  </v-date-picker>
                </v-menu>

              </v-flex>

              <v-flex xs12 sm3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_time"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Time"
                      v-model="form.time"
                      prepend-icon="access_time"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-time-picker v-model="form.time"
                  color="primary"
                  format="24hr"
                  autosave
                  @change="menu_time=false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
             <v-flex xs12 sm6>

              <v-select
                label="User"
                v-model="form.user"
                :items="users"
                item-text="firstname"
                item-value="id"
                hide-details
              ></v-select>

              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Report"
                  v-model="form.report"
                  prepend-icon="chat"
                  :rules="itemRules"
                  required
                  auto-grow
                  outlined
                  rows="5"
                  row-height="25"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import moment from 'moment';
  import FormMixin from '@/mixins/daily-form';
  export default {
    mixins: [FormMixin],
    data () {
      return {
        valid: false,
        menu_time: false,
        menu_date: false,
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.$emit('save', this.form);
        } else {
          console.log('error: daily form not valid');
        }
      },
      init (v) {
        if (v) {
          this.form.time = moment().format('HH:mm');
          this.form.date = moment().format('YYYY-MM-DD');
          this.dateFormatted = this.formatDate(this.form.date);
          this.getUsers();
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

